import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { primaryGreen } from "../utils/colors";
import {
  HomeIcon,
  DocumentTextIcon,
  QuestionMarkCircleIcon,
  BookOpenIcon,
  ArrowRightOnRectangleIcon,
  GiftIcon,
  EnvelopeIcon,
  BellIcon,
  ClipboardIcon,
  FlagIcon,
} from "@heroicons/react/24/solid";
import GetAdmin from "../utils/getAdmin";

import "../assets/fonts.css";
import { Sliders } from "lucide-react";

const Navigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [adminData, setAdminData] = useState(null);

  const isActive = (path) => {
    return location.pathname === path;
  };

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      const res = await GetAdmin();
      setAdminData(res);
      setLoading(false);
    };
    fetchData();
  }, []);

  const handleLogout = () => {
    document.cookie =
      "jwt-auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    navigate("/");
  };

  if (!adminData) {
    return null;
  }

  if (loading) {
    return (
      <div className="text-center py-8 text-gray-400">در حال بارگذاری...</div>
    );
  }

  return (
    <div className="w-full">
      <div className="bg-white rounded-lg shadow-lg p-4">
        <ul>
          {adminData.role === "manager" ? (
            <li className="mb-2">
              <button
                className={`py-2 w-full px-3 rounded-xl my-3 flex justify-start content-center 
                ${
                  isActive("/Dash")
                    ? `bg-[${primaryGreen}] text-white`
                    : `hover:text-[${primaryGreen}]`
                }`}
                onClick={() => navigate("/Dash")}
              >
                <HomeIcon className="h-5 w-5 ml-2" />
                داشبورد
              </button>
            </li>
          ) : null}
          {adminData.role === "manager" ? (
            <li className="mb-2">
              <button
                className={`py-2 w-full px-3 rounded-xl my-3 flex justify-start content-center 
                ${
                  isActive("/template")
                    ? `bg-[${primaryGreen}] text-white`
                    : `hover:text-[${primaryGreen}]`
                }`}
                onClick={() => navigate("/template")}
              >
                <ClipboardIcon className="h-5 w-5 ml-2" />
                قالب
              </button>
            </li>
          ) : null}
          {adminData.role === "manager" ? (
            <li className="mb-2">
              <button
                className={`py-2 w-full px-3 rounded-xl my-3 flex justify-start content-center 
                ${
                  isActive("/questionReport")
                    ? `bg-[${primaryGreen}] text-white`
                    : `hover:text-[${primaryGreen}]`
                }`}
                onClick={() => navigate("/questionReport")}
              >
                <FlagIcon className="h-5 w-5 ml-2" />
                گزارش سوالات
              </button>
            </li>
          ) : null}
          {adminData.role === "manager" ? (
            <li className="mb-2">
              <button
                className={`py-2 w-full px-3 rounded-xl my-3 flex justify-start content-center 
                ${
                  isActive("/slider")
                    ? `bg-[${primaryGreen}] text-white`
                    : `hover:text-[${primaryGreen}]`
                }`}
                onClick={() => navigate("/slider")}
              >
                <Sliders className="h-5 w-5 ml-2" />
                اسلایدر
              </button>
            </li>
          ) : null}
          {adminData.role !== "postMaker" ? (
            <li className="mb-2">
              <button
                className={`py-2 w-full px-3 rounded-xl my-3 flex justify-start content-center 
                ${
                  isActive("/homeWork")
                    ? `bg-[${primaryGreen}] text-white`
                    : `hover:text-[${primaryGreen}]`
                }`}
                onClick={() => navigate("/homeWork")}
              >
                <Sliders className="h-5 w-5 ml-2" />
                کاربرگ دیجیتال
              </button>
            </li>
          ) : null}
          {adminData.role !== "questionMaker" ? (
            <li className="mb-2">
              <button
                className={`py-2 w-full px-3 rounded-xl my-3 flex justify-start content-center 
                  ${
                    isActive("/ArticlePage")
                      ? `bg-[${primaryGreen}] text-white`
                      : `hover:text-[${primaryGreen}]`
                  }`}
                onClick={() => navigate("/ArticlePage")}
              >
                <DocumentTextIcon className="h-5 w-5 ml-2" />
                مقالات
              </button>
            </li>
          ) : null}
          {adminData.role !== "postMaker" ? (
            <li className="mb-2">
              <button
                className={`py-2 w-full px-3 rounded-xl my-3 flex justify-start content-center 
                  ${
                    isActive("/Question")
                      ? `bg-[${primaryGreen}] text-white`
                      : `hover:text-[${primaryGreen}]`
                  }`}
                onClick={() => navigate("/Question")}
              >
                <QuestionMarkCircleIcon className="h-5 w-5 ml-2" />
                سوالات
              </button>
            </li>
          ) : null}
          {adminData.role !== "postMaker" ? (
            <li className="mb-2">
              <button
                className={`py-2 w-full px-3 rounded-xl my-3 flex justify-start content-center 
                  ${
                    isActive("/Lesson")
                      ? `bg-[${primaryGreen}] text-white`
                      : `hover:text-[${primaryGreen}]`
                  }`}
                onClick={() => navigate("/Lesson")}
              >
                <BookOpenIcon className="h-5 w-5 ml-2" />
                درس‌ها
              </button>
            </li>
          ) : null}
          {adminData.role !== "postMaker" ? (
            <li className="mb-2">
              <button
                className={`py-2 w-full px-3 rounded-xl my-3 flex justify-start content-center 
                  ${
                    isActive("/evaluation")
                      ? `bg-[${primaryGreen}] text-white`
                      : `hover:text-[${primaryGreen}]`
                  }`}
                onClick={() => navigate("/evaluation")}
              >
                <BookOpenIcon className="h-5 w-5 ml-2" />
                گزاره های ارزشیابی توصیفی
              </button>
            </li>
          ) : null}
          {adminData.role === "manager" ? (
            <li className="mb-2">
              <button
                className={`py-2 w-full px-3 rounded-xl my-3 flex justify-start content-center 
                  ${
                    isActive("/tickets")
                      ? `bg-[${primaryGreen}] text-white`
                      : `hover:text-[${primaryGreen}]`
                  }`}
                onClick={() => navigate("/tickets")}
              >
                <EnvelopeIcon className="h-5 w-5 ml-2" />
                گزارشات
              </button>
            </li>
          ) : null}
          {adminData.role === "manager" ? (
            <li className="mb-2">
              <button
                className={`py-2 w-full px-3 rounded-xl my-3 flex justify-start content-center 
                  ${
                    isActive("/gift")
                      ? `bg-[${primaryGreen}] text-white`
                      : `hover:text-[${primaryGreen}]`
                  }`}
                onClick={() => navigate("/gift")}
              >
                <GiftIcon className="h-5 w-5 ml-2" />
                هدیه
              </button>
            </li>
          ) : null}
          {adminData.role === "manager" ? (
            <li className="mb-2">
              <button
                className={`py-2 w-full px-3 rounded-xl my-3 flex justify-start content-center 
                  ${
                    isActive("/notice")
                      ? `bg-[${primaryGreen}] text-white`
                      : `hover:text-[${primaryGreen}]`
                  }`}
                onClick={() => navigate("/notice")}
              >
                <BellIcon className="h-5 w-5 ml-2" />
                اعلان
              </button>
            </li>
          ) : null}
          {/* خروج */}
          <li className="mt-6 pt-4 border-t border-gray-200">
            <button
              onClick={handleLogout}
              className="w-full p-3 rounded-lg hover:bg-red-100 text-red-600 transition duration-200"
            >
              <div className="flex items-center">
                <ArrowRightOnRectangleIcon className="h-5 w-5 ml-2" />
                خروج
              </div>
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Navigation;
